import type { ParallaxSvgSpec } from '../../../../config/atmosphere/effectLayer.types';
import { placeWorldShape, type ShapePlacement } from './worldShapeKit';

/** Recompose existing shapes at their intended horizontal size. Matching the
 * viewBox and display heights keeps a tall far plane from magnifying both axes.
 * Geometry is built once; the existing parallax consumer only moves it. */
function branchTile(height: number, shapes: readonly ShapePlacement[], bank = ''): ParallaxSvgSpec {
  return { tile: { viewBoxWidth: 2400, viewBoxHeight: height,
    path: [bank, ...shapes.map(shape => placeWorldShape(...shape))].filter(Boolean).join(' ') } };
}

export const BRANCH_DEPTH_HEIGHTS = { moonfen: 1400, moonfall: 1440, fungal: 940 } as const;

export const BRANCH_DEPTH_BACKDROPS = {
  // Two narrow willows rise behind the rim. The bank stays in the lowest tenth
  // of the tile, leaving the long upper descent in open marsh air.
  moonfen: branchTile(BRANCH_DEPTH_HEIGHTS.moonfen, [
    ['willow', 160, 1400, 360, 1250], ['willow', 1460, 1400, 320, 1170],
    ['reeds', 770, 1400, 190, 420], ['reeds', 2140, 1400, 160, 300],
  ], 'M0 1400V1270Q180 1270 350 1250L600 1250Q830 1290 1050 1275'
    + 'L1320 1275Q1550 1240 1770 1265L2080 1265Q2250 1270 2400 1270V1400Z'),
  // Open ribs and slender columns suggest a distant observatory vault. No
  // filled crag wall is enlarged behind the playable gallery or shrine.
  moonfall: branchTile(BRANCH_DEPTH_HEIGHTS.moonfall, [
    ['column', 190, 1440, 84, 1210], ['ribs', 410, 1440, 330, 1110],
    ['crystal', 1050, 1440, 170, 380], ['ribs', 1440, 1440, 330, 1250],
    ['column', 1880, 1440, 92, 1110],
  ]),
  // A few distinct caps reach the upper survey route. Transparent space
  // between their stems keeps the saturated fungal light bed breathable.
  fungal: branchTile(BRANCH_DEPTH_HEIGHTS.fungal, [
    ['mushroom', 130, 940, 420, 650], ['mushroom', 690, 940, 180, 280],
    ['mushroom', 1020, 940, 360, 560], ['mushroom', 1740, 940, 460, 700],
  ]),
} satisfies Record<keyof typeof BRANCH_DEPTH_HEIGHTS, ParallaxSvgSpec>;
